import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "sheet",
  "use": "sheet-usage",
  "viewBox": "0 0 17 16",
  "content": "<symbol viewBox=\"0 0 17 16\" id=\"sheet\"><path d=\"M17 16H0V0h17v16zM1 15h15V1H1v14zm6.868-4.625h-5.74V2.813h5.74v7.562zm-4.741-1h3.74V3.813h-3.74v5.562zm-.849 3.813h12.369v-1.002H2.278v1.002zm7.304-2.813h5.173V9.374H9.582v1.001zm0-3.75h5.173v-1H9.582v1zm0-2.812h5.173v-1H9.582v1z\" /></symbol>"
});
var result = sprite.add(symbol);
export default "#" + symbol.id


//////////////////
// WEBPACK FOOTER
// ./application/components/dumb/icon/src/sheet.svg
// module id = 185
// module chunks = 0